import { render, staticRenderFns } from "./GenericDiagnosticsHistoryTab.vue?vue&type=template&id=19ebf1d3&scoped=true&"
import script from "./GenericDiagnosticsHistoryTab.vue?vue&type=script&lang=js&"
export * from "./GenericDiagnosticsHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./GenericDiagnosticsHistoryTab.vue?vue&type=style&index=0&id=19ebf1d3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ebf1d3",
  null
  
)

export default component.exports